// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"Menu_fullscreen__1zZ7T","header":"Menu_header__2hlkb"};